import React from 'react'
import { AllCardsType } from '../../../data/all-cards'
import { randomNumberInRange } from '../../../utils/functions'

const PhotoCards = ({ cards, mazo, tapiz }: { cards: AllCardsType[]; mazo: string; tapiz: string }) => {
    return (
        <div className="relative mini:w-[80vw] mini:h-[52vw] xl:w-[65vw] xl:h-[44vw] after:bg-white-gradient after:absolute after:w-full after:h-full after:z-20 after:top-0 after-left-0 overflow-hidden">
            <div
                className={`absolute inset-[-240px] bg-cover`}
                style={{
                    transform: `rotate(${randomNumberInRange(-5, 5)}deg) translateY(${
                        randomNumberInRange(-40, 40) + 'px'
                    }) translateX(${randomNumberInRange(-40, 40) + 'px'})`,
                    backgroundImage: `url(/fondos/${tapiz}.jpg)`,
                }}
            ></div>
            <div className="relative flex flex-nowrap items-center justify-center w-full h-full mini:px-4 mini:py-12 xl:px-6 xl:py-16 mini:gap-2 xl:gap-4">
                {cards.map((card: AllCardsType, index: number) => {
                    return (
                        <img
                            key={index}
                            src={require('../../../assets/' + mazo + card.url + '/' + card.image)}
                            className={
                                card.url === 'mayores'
                                    ? 'w-[8.2vw] h-auto mini:rounded-sm xl:rounded-[10px] box-shadow-[5px_5px_2px_rgba(0,0,0,1)]'
                                    : 'bg-white w-[8.2vw] h-auto mini:rounded-sm xl:rounded-[10px] box-shadow-[5px_5px_2px_rgba(0,0,0,1)]'
                            }
                            style={{
                                transform:
                                    'rotate(' +
                                    `${
                                        card.position !== 'invertida'
                                            ? randomNumberInRange(-5, 5)
                                            : randomNumberInRange(175, 185)
                                    }` +
                                    'deg) translateY(' +
                                    randomNumberInRange(-12, 12) +
                                    'px',
                            }}
                            alt=""
                        />
                    )
                })}
            </div>
        </div>
    )
}

export default PhotoCards
